import { render } from "./nav.vue?vue&type=template&id=089466bc&scoped=true&ts=true"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"

import "./nav.vue?vue&type=style&index=0&id=089466bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089466bc"]])

export default __exports__